module.exports = __webpack_public_path__ + "static/media/COMO CREO MI CUENTA DE KALLPA CAMBIOS.e30fcbb.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/COMO CREO MI CUENTA DE KALLPA CAMBIOS.mp4
// module id = vNwc
// module chunks = 1